;(function (angular, _) {
  'use strict'

  class ChorusContainer {
    constructor (
      // Angular
      // Libs
      $uibModal, $state,
      // Managers
      ChorusMonitoringManager, CreditNoteManager, InvoiceManager,
      // Services
      ChorusService, SnackService,
      // Const
      // Resolved
      populates
    ) {
      this.uibModal = $uibModal
      this.chorusService = ChorusService
      this.chorusMonitoringManager = ChorusMonitoringManager
      this.state = $state
      this.snackService = SnackService
      this.elementType = 'facture'
      this.currentIntegrationStatus = null
      this.statusStyle = ''
      this.monitoring = null
      this.integrationLoading = false
      this.isCreditNote = false
      this.CreditNoteManager = CreditNoteManager
      this.InvoiceManager = InvoiceManager
      this.populates = populates
    }

    $onInit () {
      this.element.getType() === 'creditNote' ? (this.elementType = 'avoir', this.isCreditNote = true) : this.elementType = 'facture'
      this.handleFluxStatus()
      if (this.element.chorusFields?.lastFluxMonitoringId) {
        this.getMonitoring(this.element.chorusFields.lastFluxMonitoringId).then((monitoring) => {
          if (monitoring?.status === 'completed' &&
          !this.element.chorusFields?.integratedOnChorus &&
          !this.element.chorusFields?.isInErrorState
          ) {
            this.refreshIntegrationStatus(monitoring._id)
          }
        })
      }
    }

    getMonitoring (id) {
      const temp = angular.copy(this.monitoring)
      this.monitoring = null
      return this.chorusMonitoringManager.getById(id)
        .then((data) => {
          this.monitoring = data
          this.handleFluxStatus(true)
          if (temp?.status === 'pending' && this.monitoring.status === 'failed') {
            this.updateElement()
            this.snackService.snack({
              text: `Une erreur est survenue lors de l'intégration sur Chorus.`,
              delay: 5000
            })
          }
          return this.monitoring
        })
    }

    handleFluxStatus (isMonitoring) {
      if (!isMonitoring) {
        switch (true) {
          case this.element.chorusFields?.integratedOnChorus:
            this.currentIntegrationStatus = 'Intégré'
            this.statusStyle = 'text-success bg-success'
            break
          case this.element.chorusFields?.integrationOngoing:
            this.currentIntegrationStatus = 'En cours'
            this.statusStyle = 'text-info bg-info'
            break
          case this.element.chorusFields?.isInErrorState:
            this.currentIntegrationStatus = 'Erreur'
            this.statusStyle = 'text-danger bg-danger'
            break
        }
      } else {
        if (this.monitoring.status === 'failed') {
          this.currentIntegrationStatus = 'Erreur'
          this.statusStyle = 'text-danger bg-danger'
        }
        if (this.monitoring.status === 'pending') {
          this.currentIntegrationStatus = 'En cours'
          this.statusStyle = 'text-info bg-info'
        }
      }
    }

    refreshIntegrationStatus (id) {
      this.integrationLoading = true
      this.chorusService.checkIntegration(id, this.isCreditNote).then((response) => {
        this.integrationLoading = false
        if (response.data.status === 'success') {
          this.snackService.snack({
            text: `${_.startCase(this.elementType)} créée avec succès sur Chorus.`,
            delay: 5000
          })
          return this.updateElement()
        } else if (response.data.status === 'failure') {
          this.snackService.snack({
            text: `Une erreur est survenue lors de l'intégration sur Chorus.`,
            delay: 5000
          })
          return this.updateElement()
        } else {
          return null
        }
      })
    }

    copyToClipboard (jsonPayload) {
      navigator.clipboard.writeText(JSON.stringify(jsonPayload, null, '\t'))
    }

    updateElement () {
      let manager
      let populate
      if (this.isCreditNote) {
        manager = this.CreditNoteManager
        populate = this.populates.show.creditNote
      } else {
        manager = this.InvoiceManager
        populate = this.populates.show.invoice
      }
      let query = manager.query({ populate: populate })

      return manager.getById(this.element._id, query).then((data) => {
        this.element.chorusFields = data.chorusFields
      })
    }
  }

  ChorusContainer.$inject = [
    // Angular
    // Libs
    '$uibModal', '$state',
    // Managers
    'ChorusMonitoringManager', 'CreditNoteManager', 'InvoiceManager',
    // Services
    'ChorusService', 'SnackService',
    // Const
    // Resolved
    'populates'
  ]

  angular.module('kilo.common.components')
    .component('chorusContainer', {
      bindings: {
        element: '='
      },
      controllerAs: '$ctrl',
      templateUrl: '/app/common/components/chorus-container/components/chorus-container.template.html',
      controller: ChorusContainer
    })
})(window.angular, window._)
